import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import Info from './Info';
import styles from './../../Assets/CSS/Register.module.css';
import inputStyles from './../../Assets/CSS/Input.module.css';
import { BlueButton } from './../../Components/Button';
import axios from 'axios';
import { BASE_URL } from './../../Environment';
import { toast } from 'react-toastify';

function BankAccount() {
    const accessToken = localStorage.getItem('accessToken');
    const [isLoading, setIsLoading] = useState(false);
    const [bank_name, setBankName] = useState('');
    const [branch_name, setBranchName] = useState('');
    const [acc_no, setAccNo] = useState('');
    const [ifsc_code, setIfscCode] = useState('');
    const [customBankName, setCustomBankName] = useState(''); 
    const bankList = [
        'State Bank of India',
        'HDFC Bank',
        'ICICI Bank',
        'Axis Bank',
        'Punjab National Bank',
        'Bank of Baroda',
        'Kotak Mahindra Bank',
        'Union Bank of India',
        'Canara Bank',
        'Yes Bank'
    ]; 
    useEffect(() => {
        document.title = 'Infomart | Agent Bank Account';
        axios.get(`${BASE_URL}/agent/details`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            const data = res.data.data;
            setBankName(data.bank_name);
            setBranchName(data.branch_name);
            setAccNo(data.acc_no);
            setIfscCode(data.ifsc_code);
        }).catch((res) => {
            if (res.response.status === 401) {
                ['loginAs', 'accessToken'].forEach(item => localStorage.removeItem(item));
                window.location.reload();
            } else {
                toast.error(res.response.data.msg, { autoClose: 3000 });
            }
        });
    }, []);
    const handleSubmit = async () => {
        setIsLoading(true);
        const selectedBankName = bank_name === 'Other' ? customBankName : bank_name;
        if (!selectedBankName || !branch_name || !acc_no || !ifsc_code) {
            toast.error('Please fill in all required fields.', { autoClose: 3000 });
            setIsLoading(false);
            return;
        } 
        await axios.post(`${BASE_URL}/agent/bank-account`, {
            bank_name: selectedBankName,
            branch_name,
            acc_no,
            ifsc_code
        }, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`
            }
        }).then((res) => {
            toast.success(res.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        }).catch((res) => {
            toast.error(res.response.data.msg, { autoClose: 3000 });
            setIsLoading(false);
        });
    }; 
    const handleIFSCBlur = async () => {
        if (ifsc_code.trim().length !== 11) {
            toast.error('Invalid IFSC code. It should be 11 characters.', { autoClose: 3000 });
            return;
        } 
        try {
            const res = await axios.get(`https://ifsc.razorpay.com/${ifsc_code.trim()}`);
            if (res.data && res.data.BRANCH) {
                setBranchName(res.data.BRANCH);
            } else {
                toast.error('Branch not found for this IFSC code.', { autoClose: 3000 });
            }
        } catch (err) {
            toast.error('Invalid IFSC code or unable to fetch branch.', { autoClose: 3000 });
        } 
    }; 
    return (
        <div className="app">
            <div className="outlet">
                <Info />
                <div className="homeLayout">
                    <Sidebar />
                    <div className={styles.individualFormContainer} style={{ width: '100%', marginBottom: 0 }}>
                        <div className={styles.top}>
                            <div className="w-100">
                                <h4 className="text-left" style={{ whiteSpace: 'nowrap' }}>Update Bank Account</h4>
                            </div>
                        </div>
                        <div id='not-row-a' className={styles.row}>
                            <div className="col">
                                <label className="mb-2">Bank Name *</label>
                                <select
                                    className={inputStyles.dropdown} 
                                    value={bank_name}
                                    onChange={e => setBankName(e.target.value)}
                                >
                                    <option value="">-- Select Bank --</option>
                                    {bankList.map((bank, index) => (
                                        <option key={index} value={bank}>{bank}</option>
                                    ))}
                                    <option value="Other">Other</option>
                                </select> 
                                {bank_name === "Other" && (
                                    <input
                                        type="text"
                                        className={`${inputStyles.input} mt-2`}
                                        placeholder="Enter your bank name"
                                        value={customBankName}
                                        onChange={e => setCustomBankName(e.target.value)}
                                    />
                                )}
                            </div>
                            <div className="col">
                                <label className="mb-2">Account No. *</label>
                                <input
                                    type="text"
                                    className={inputStyles.input}
                                    value={acc_no}
                                    onChange={e => setAccNo(e.target.value)}
                                />
                            </div> 
                        </div>
                        <div id='not-row-a' className={styles.row}> 
                            <div className="col">
                                <label className="mb-2">IFSC Code *</label>
                                <input
                                    type="text"
                                    className={inputStyles.input}
                                    value={ifsc_code}
                                    onChange={e => setIfscCode(e.target.value)}
                                    onBlur={handleIFSCBlur}
                                    placeholder="Enter IFSC code"
                                />
                            </div> 
                            <div className="col">
                                <label className="mb-2">Branch Name *</label>
                                <input
                                    type="text"
                                    className={inputStyles.input}
                                    value={branch_name}
                                    onChange={e => setBranchName(e.target.value)}
                                />
                            </div> 
                        </div>
                        <div className="mt-4">
                            <BlueButton title={isLoading ? "Loading..." : "Submit"} onClick={handleSubmit} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BankAccount;
 